export default __webpack_public_path__ + "static/media/discovery_lesson_image.63312a71.png";